import PropTypes from 'prop-types';
import SimpleTable from 'components/Commun/Table/SimpleTable';
import React from 'react';

const TableauArmePerdueVolee = ({ donnees }) => {
    const tableauConfigHeader = [
        "Numéro d'encodage",
        'Numéro de série',
        'Type',
        'Marque',
        'Modèle',
        'Calibre Canon 1',
        'Calibre Canon 2',
        'Classement',
        'Statut',
        donnees.length > 1 ? 'Actions' : null,
    ];

    return (
        <SimpleTable
            entete={tableauConfigHeader}
            donnees={donnees.map((elem) => {
                return Object.values(elem);
            })}
        />
    );
};

TableauArmePerdueVolee.propTypes = {
    donnees: PropTypes.array.isRequired,
};

export default TableauArmePerdueVolee;
